import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b78881e")

_pushScopeId("data-v-9b78881e")
const _hoisted_1 = { class: "dhm_success" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dhm_gift_bg" }, null, -1)
const _hoisted_3 = { class: "success_desc" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "my_tequan" }, "我的特权", -1)
const _hoisted_5 = { class: "tequan_list" }
const _hoisted_6 = { class: "flex_space_center" }
const _hoisted_7 = { class: "flex_start_center tequan_desc_obj" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, _toDisplayString(_ctx.viewModel.exchangeInfo?.vip_info_list[0]?.page_detail?.name) + "兑换成功", 1),
      _createVNode("div", null, "有效期：" + _toDisplayString(_ctx.viewModel.exchangeInfo?.exchangeDateDesc), 1)
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("ul", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.myTequanList, (item, idx) => {
          return (_openBlock(), _createBlock("li", {
            key: idx,
            class: "flex_start_center"
          }, [
            _createVNode("i", {
              class: item.iconClass
            }, null, 2),
            _createVNode("div", null, [
              _createVNode("div", null, _toDisplayString(item.label), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("i", {
                  class: { active: item.status }
                }, null, 2),
                _createVNode("span", null, _toDisplayString(item.num) + "项特权", 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", {
      class: "confirm_btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickConfirm && _ctx.clickConfirm(...args)))
    }, "确定")
  ]))
})